export const authInputClassName =
  "w-full rounded-xl border border-[var(--yb-border)] bg-white px-4 py-3 text-base text-slate-900 placeholder:text-slate-500 transition hover:border-slate-300 focus:border-[var(--yb-focus)] focus:outline-none focus:ring-2 focus:ring-[var(--yb-focus)] disabled:cursor-not-allowed disabled:opacity-60";

export const authLabelClassName = "text-sm font-medium text-slate-900";

export const authForgotLinkClassName =
  "text-sm font-medium text-slate-500 transition hover:text-[var(--color-primary)] hover:underline focus-visible:text-[var(--color-primary)] focus-visible:underline";

export const authSwitchLinkClassName =
  "font-semibold text-[var(--color-primary)] transition hover:underline focus-visible:underline";

export const authPrimaryButtonClassName =
  "yb-primary-button w-full rounded-xl py-3 text-base font-semibold !text-white hover:!text-white active:!text-white focus-visible:!text-white disabled:cursor-not-allowed disabled:!text-white disabled:opacity-60";

export const authGoogleButtonClassName =
  "flex w-full items-center justify-center gap-2 rounded-xl border border-[var(--yb-border)] bg-white py-3 font-medium text-slate-900 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60";

export const authErrorClassName =
  "mb-4 rounded-lg border border-rose-200 bg-rose-50/80 px-4 py-3 text-sm text-rose-700";
